module.exports = __webpack_public_path__ + "static/media/github.a112a001.svg";